import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { createContext, useCallback, useState } from "react";
import { useDebounce, useDebouncedCallback } from "use-debounce";
export const USelectContext = createContext(null);
const emptyFnc = () => void 0;
export const USelectProviders = ({ children, onSearch = emptyFnc, onDropdownHidden, onDropdownShow, }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [search, setSearch] = useState("");
    useEffect(() => {
        if (showDropdown) {
            onDropdownShow?.();
        }
        else {
            onDropdownHidden?.();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showDropdown]);
    const [debounceSearch] = useDebounce(search || "", 800);
    const debouncedOnSearch = useDebouncedCallback(onSearch, 800);
    const handleSearch = useCallback((value) => {
        setSearch(value);
        debouncedOnSearch(value);
    }, [debouncedOnSearch]);
    const immediatelySetSearch = useCallback((value) => {
        setSearch(value);
        onSearch(value);
    }, [onSearch]);
    const ctx = {
        showDropdown,
        setShowDropdown,
        search,
        debounceSearch: debounceSearch,
        immediatelySetSearch: immediatelySetSearch,
        setSearch: handleSearch,
    };
    return _jsx(USelectContext.Provider, { value: ctx, children: children });
};
